// Knights Two Data - Group Two (Mysterious & Complex Knights)

// Sir Tristan of Lyonesse's workout programs
const tristanPrograms = [
    {
        id: 'knight-minstrel-training',
        name: 'Knight-Minstrel Training',
        description: 'Elegant conditioning that combines warrior strength with artistic grace',
        pattern: 'x&*$:+',
        reps: 14,
        sets: 4,
        focus: 'Artistic Warrior'
    },
    {
        id: 'cornish-blue-conditioning',
        name: 'Cornish Blue Conditioning',
        description: 'Coastal strength training from the rugged shores of Cornwall',
        pattern: '*$x&:+',
        reps: 16,
        sets: 3,
        focus: 'Coastal Power'
    },
    {
        id: 'harp-and-sword-protocol',
        name: 'Harp and Sword Protocol',
        description: 'Dual mastery training for both musical and martial excellence',
        pattern: '&:x$*+',
        reps: 12,
        sets: 5,
        focus: 'Dual Mastery'
    },
    {
        id: 'swan-feather-strength',
        name: 'Swan Feather Strength',
        description: 'Graceful power that embodies the beauty and majesty of swans',
        pattern: '+*&:x$',
        reps: 18,
        sets: 4,
        focus: 'Graceful Majesty'
    },
    {
        id: 'romantic-legend-training',
        name: 'Romantic Legend Training',
        description: 'Passionate conditioning that channels deep emotion into physical power',
        pattern: 'xx::&&',
        reps: 20,
        sets: 3,
        focus: 'Passionate Power'
    },
    {
        id: 'lyonesse-mastery-conditioning',
        name: 'Lyonesse Mastery Conditioning',
        description: 'The complete training of Cornwall\'s greatest knight-poet',
        pattern: 'x&*$:+!!',
        reps: 22,
        sets: 3,
        focus: 'Poetic Mastery'
    }
];

// Sir Lamorak de Galis's workout programs
const lamorakPrograms = [
    {
        id: 'round-table-strength-training',
        name: 'Round Table Strength Training',
        description: 'Powerhouse conditioning for one of the strongest knights of Camelot',
        pattern: '>=$*&x',
        reps: 18,
        sets: 4,
        focus: 'Maximum Strength'
    },
    {
        id: 'black-lion-conditioning',
        name: 'Black Lion Conditioning',
        description: 'Predatory power training that embodies the fierce black lion',
        pattern: '$>&x*=',
        reps: 21,
        sets: 3,
        focus: 'Predatory Force'
    },
    {
        id: 'two-handed-sword-protocol',
        name: 'Two-Handed Sword Protocol',
        description: 'Massive weapon mastery requiring overwhelming physical power',
        pattern: 'x=$>&*',
        reps: 15,
        sets: 5,
        focus: 'Massive Weapons'
    },
    {
        id: 'battle-scarred-warrior-training',
        name: 'Battle-Scarred Warrior Training',
        description: 'Hardened conditioning from countless medieval battlefields',
        pattern: '&*$>=x',
        reps: 19,
        sets: 4,
        focus: 'Battle Hardened'
    },
    {
        id: 'iron-warhorse-strength',
        name: 'Iron Warhorse Strength',
        description: 'Heavy cavalry conditioning for the most powerful war destriers',
        pattern: '>>==$$',
        reps: 24,
        sets: 3,
        focus: 'Heavy Cavalry'
    },
    {
        id: 'galis-champion-mastery',
        name: 'Galis Champion Mastery',
        description: 'The ultimate strength training that forged a Round Table legend',
        pattern: '>=$*&x!!',
        reps: 26,
        sets: 3,
        focus: 'Legendary Strength'
    }
];

// Sir Garlon the Invisible Knight's workout programs
const garlonPrograms = [
    {
        id: 'invisible-knight-training',
        name: 'Invisible Knight Training',
        description: 'Mysterious conditioning that develops power without presence',
        pattern: ';+x&*>',
        reps: 13,
        sets: 6,
        focus: 'Invisible Power'
    },
    {
        id: 'shadow-absorption-conditioning',
        name: 'Shadow Absorption Conditioning',
        description: 'Dark training methods that seem to absorb light itself',
        pattern: 'x;+>&*',
        reps: 11,
        sets: 7,
        focus: 'Shadow Mastery'
    },
    {
        id: 'midnight-steel-protocol',
        name: 'Midnight Steel Protocol',
        description: 'Black metal conditioning for weapons of strange and terrible power',
        pattern: '*>;&+x',
        reps: 16,
        sets: 4,
        focus: 'Dark Steel'
    },
    {
        id: 'unsettling-presence-training',
        name: 'Unsettling Presence Training',
        description: 'Psychological warfare through mysterious and unnerving strength',
        pattern: '&+x;*>',
        reps: 14,
        sets: 5,
        focus: 'Psychological Edge'
    },
    {
        id: 'silent-stallion-strength',
        name: 'Silent Stallion Strength',
        description: 'Soundless power training for mount and rider that move like ghosts',
        pattern: '++;;>>',
        reps: 17,
        sets: 4,
        focus: 'Ghostly Movement'
    },
    {
        id: 'mystery-mastery-conditioning',
        name: 'Mystery Mastery Conditioning',
        description: 'The complete training of the most enigmatic knight who ever lived',
        pattern: ';+x&*>!!',
        reps: 20,
        sets: 3,
        focus: 'Enigmatic Mastery'
    }
];

// Sir Balin le Savage's workout programs
const balinPrograms = [
    {
        id: 'knight-of-two-swords-training',
        name: 'Knight of Two Swords Training',
        description: 'Dual weapon mastery requiring incredible coordination and strength',
        pattern: '*x>&$+',
        reps: 16,
        sets: 4,
        focus: 'Dual Weapons'
    },
    {
        id: 'savage-warrior-conditioning',
        name: 'Savage Warrior Conditioning',
        description: 'Fierce and relentless training for the most aggressive combat style',
        pattern: '>*x&$+',
        reps: 19,
        sets: 3,
        focus: 'Savage Aggression'
    },
    {
        id: 'dolorous-stroke-protocol',
        name: 'Dolorous Stroke Protocol',
        description: 'Devastating power training capable of legendary destructive force',
        pattern: 'x+>&*$',
        reps: 22,
        sets: 4,
        focus: 'Devastating Power'
    },
    {
        id: 'blood-stained-training',
        name: 'Blood-Stained Training',
        description: 'Brutal conditioning that mirrors a life of constant warfare',
        pattern: '$&+>*x',
        reps: 17,
        sets: 5,
        focus: 'Brutal Warfare'
    },
    {
        id: 'scarred-destrier-strength',
        name: 'Scarred Destrier Strength',
        description: 'Battle-tested mount conditioning for horses that know only war',
        pattern: '**>>$$',
        reps: 21,
        sets: 3,
        focus: 'War Mount'
    },
    {
        id: 'tragic-doom-mastery',
        name: 'Tragic Doom Mastery',
        description: 'The complete training of a knight doomed to greatness and sorrow',
        pattern: '*x>&$+!!',
        reps: 25,
        sets: 3,
        focus: 'Doomed Greatness'
    }
];

// Sir Bors de Ganis's workout programs
const borsPrograms = [
    {
        id: 'grail-survivor-training',
        name: 'Grail Survivor Training',
        description: 'The only knight to achieve the Grail and return to tell the tale',
        pattern: '+>=$&*',
        reps: 12,
        sets: 6,
        focus: 'Divine Survivor'
    },
    {
        id: 'humble-strength-conditioning',
        name: 'Humble Strength Conditioning',
        description: 'Practical power that serves duty rather than glory',
        pattern: '=+>&$*',
        reps: 15,
        sets: 4,
        focus: 'Humble Service'
    },
    {
        id: 'blue-cross-protocol',
        name: 'Blue Cross Protocol',
        description: 'Sacred symbol training for the bearer of divine favor',
        pattern: '&*+=x>',
        reps: 13,
        sets: 5,
        focus: 'Sacred Symbol'
    },
    {
        id: 'reliable-warrior-training',
        name: 'Reliable Warrior Training',
        description: 'Steadfast conditioning that never fails when others depend on it',
        pattern: '>x&*+=',
        reps: 18,
        sets: 4,
        focus: 'Unwavering Duty'
    },
    {
        id: 'divine-mystery-strength',
        name: 'Divine Mystery Strength',
        description: 'Training informed by witnessing the greatest of all sacred mysteries',
        pattern: '++==>>',
        reps: 20,
        sets: 3,
        focus: 'Divine Witness'
    },
    {
        id: 'ganis-legacy-mastery',
        name: 'Ganis Legacy Mastery',
        description: 'The complete training of the knight who bridged earthly and divine realms',
        pattern: '+>=$&*!!',
        reps: 23,
        sets: 3,
        focus: 'Divine Bridge'
    }
];

// Sir Bedivere the Bold's workout programs
const bediverePrograms = [
    {
        id: 'one-handed-knight-training',
        name: 'One-Handed Knight Training',
        description: 'Adaptive conditioning that turns disability into devastating advantage',
        pattern: '>*$x&+',
        reps: 14,
        sets: 5,
        focus: 'Adaptive Excellence'
    },
    {
        id: 'loyal-companion-conditioning',
        name: 'Loyal Companion Conditioning',
        description: 'Faithful strength training for Arthur\'s most trusted friend',
        pattern: '*>$&x+',
        reps: 16,
        sets: 4,
        focus: 'Faithful Strength'
    },
    {
        id: 'excalibur-guardian-protocol',
        name: 'Excalibur Guardian Protocol',
        description: 'Sacred duty training for the guardian of the legendary sword',
        pattern: '$+>*&x',
        reps: 11,
        sets: 7,
        focus: 'Sacred Guardian'
    },
    {
        id: 'royal-blue-training',
        name: 'Royal Blue Training',
        description: 'Noble conditioning worthy of bearing Arthur\'s own colors',
        pattern: '&x+>*$',
        reps: 17,
        sets: 4,
        focus: 'Royal Service'
    },
    {
        id: 'unshakeable-dignity-strength',
        name: 'Unshakeable Dignity Strength',
        description: 'Noble bearing that shows no weakness despite physical limitations',
        pattern: '>>$$**',
        reps: 19,
        sets: 3,
        focus: 'Noble Dignity'
    },
    {
        id: 'arthur-faithful-mastery',
        name: 'Arthur\'s Faithful Mastery',
        description: 'The ultimate training of Arthur\'s most loyal and trusted knight',
        pattern: '>*$x&+!!',
        reps: 21,
        sets: 3,
        focus: 'Ultimate Loyalty'
    }
];

// Main Knights Two trainers data object - Group Two
const knightsTwoTrainersData = {
    'sir-tristan-of-lyonesse': {
        id: 'sir-tristan-of-lyonesse',
        name: 'Sir Tristan of Lyonesse',
        title: 'The Knight-Minstrel',
        specialization: 'Artistic Combat & Musical Warfare',
        image: '/assets/images/Sir-Tristan-of-Lyonesse.jpg',
        experience: '35+ years',
        category: 'knights-two',
        color: '#4169E1',
        secondaryColor: '#FFD700',
        intro: `The greatest knight-minstrel of his age, Tristan masters both harp and sword with equal skill. His Cornish blue surcoat decorated with golden harps reflects his dual nature as warrior and artist. His training teaches that true strength flows from passion and creativity - showing that the greatest knights are those who can inspire as well as conquer.`,
        programs: tristanPrograms
    },
    'sir-lamorak-de-galis': {
        id: 'sir-lamorak-de-galis',
        name: 'Sir Lamorak de Galis',
        title: 'The Strongest Knight',
        specialization: 'Maximum Strength & Heavy Combat',
        image: '/assets/images/Sir-Lamorak-de-Galis.jpg',
        experience: '42+ years',
        category: 'knights-two',
        color: '#8B0000',
        secondaryColor: '#000000',
        intro: `Renowned as one of the physically strongest knights of the Round Table, Lamorak wields massive two-handed weapons with devastating effect. His deep red surcoat with the black lion rampant strikes fear into enemies. His training philosophy emphasizes raw power - teaching that sometimes overwhelming force is the most noble path to victory.`,
        programs: lamorakPrograms
    },
    'sir-garlon-the-invisible-knight': {
        id: 'sir-garlon-the-invisible-knight',
        name: 'Sir Garlon the Invisible',
        title: 'The Unseen Warrior',
        specialization: 'Stealth Combat & Psychological Warfare',
        image: '/assets/images/Sir-Garlon-the-Invisible-Knight.jpg',
        experience: '30+ years',
        category: 'knights-two',
        color: '#000000',
        secondaryColor: '#C0C0C0',
        intro: `The most mysterious knight of legend, possessing the supernatural ability to become invisible. His midnight black mail absorbs light itself, and his presence unsettles even the bravest warriors. His training reveals that the greatest strength often comes from what remains unseen - teaching students to develop power that operates beyond normal perception.`,
        programs: garlonPrograms
    },
    'sir-balin-le-savage': {
        id: 'sir-balin-le-savage',
        name: 'Sir Balin le Savage',
        title: 'Knight of Two Swords',
        specialization: 'Dual Weapon Mastery & Aggressive Combat',
        image: '/assets/images/Sir-Balin-le-Savage.jpg',
        experience: '28+ years',
        category: 'knights-two',
        color: '#8B0000',
        secondaryColor: '#2F2F2F',
        intro: `The tragic knight who wields two swords and is destined for both greatness and doom. His blood-stained surcoat tells the story of constant warfare, while his fierce intensity burns like an unquenchable fire. His training teaches that sometimes the greatest strength comes from accepting one's fate and fighting with everything you have.`,
        programs: balinPrograms
    },
    'sir-bors-de-ganis': {
        id: 'sir-bors-de-ganis',
        name: 'Sir Bors de Ganis',
        title: 'The Grail Survivor',
        specialization: 'Sacred Combat & Divine Endurance',
        image: '/assets/images/Sir-Bors-de-Ganis.jpg',
        experience: '48+ years',
        category: 'knights-two',
        color: '#FFFFFF',
        secondaryColor: '#4169E1',
        intro: `The only knight to achieve the Holy Grail and return to the world, Bors bridges the gap between earthly duty and divine calling. His white surcoat with blue crosses reflects his sacred mission. His training emphasizes reliable strength over flashy technique - proving that humble, consistent power often achieves what brilliance cannot.`,
        programs: borsPrograms
    },
    'sir-bedivere-the-bold': {
        id: 'sir-bedivere-the-bold',
        name: 'Sir Bedivere the Bold',
        title: 'Arthur\'s Faithful Companion',
        specialization: 'Adaptive Combat & Loyal Service',
        image: '/assets/images/Sir-Bedivere-the-Bold.jpg',
        experience: '45+ years',
        category: 'knights-two',
        color: '#4169E1',
        secondaryColor: '#FFD700',
        intro: `Arthur's most trusted companion and the guardian of Excalibur, despite losing his hand in battle. His royal blue and gold surcoat bears Arthur's own arms, marking his special status. His training shows that true strength comes not from perfection, but from overcoming limitations with courage, dignity, and unwavering loyalty.`,
        programs: bediverePrograms
    }
};

// Export the data
export default knightsTwoTrainersData;